module.exports = __webpack_public_path__ + "img/img-bajo@2x.f9cff784.jpg";